module.exports = __webpack_public_path__ + "static/img/rc.f3b6f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/rc.jpg
// module id = 212
// module chunks = 1